module.exports = __webpack_public_path__ + "img/collection-engagementRingsDiamond@2x.739faee.jpg";